import { useCallback, useMemo, useState } from 'react'
import { Button, Row, Col } from 'antd'
import moment from 'moment'
import TbsjtjAsj from '@/pages/Tbqy/components/TbsjtjAsj'
import TbsjtjAbm from '@/pages/Tbqy/components/TbsjtjAbm'
import Dttbjgxm from '@/pages/Tbqy/components/Dttbjgxm'
import QysjtjAsj from '@/pages/Tbqy/components/QysjtjAsj'
import QysjtjAbm from '@/pages/Tbqy/components/QysjtjAbm'
import QysjtjHor from '@/pages/Tbqy/components/QysjtjHor'
import Bndsfhttj from '@/pages/Tbqy/components/Bndsfhttj'
import LastSjtj from '@/pages/Tbqy/components/LastSjtj'

const Index = () => {
  const [updateTime, setUpdateTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'))

  const handleFlush = useCallback(() => {
    setUpdateTime(moment().format('YYYY-MM-DD HH:mm:ss'))
  }, [])

  const visibleMessage = useMemo(() => {
    return `以下数据截至今天${moment(updateTime).format('HH:mm')}，`
  }, [updateTime])

  return (
    <div>
      <div className='text-center'>{visibleMessage}如需实时数据请手动 <Button type="link" onClick={handleFlush}>刷新</Button></div>
      <Row gutter={[16, 16]} className='mb-20'>
        <Col span={16}>
          <TbsjtjAsj updateTime={updateTime} />
          <div className='mt-16'></div>
          <TbsjtjAbm updateTime={updateTime} />
        </Col>
        <Col span={8}>
          <div style={{height: '750px'}}>
            <Dttbjgxm updateTime={updateTime} />
          </div>
        </Col>
        <Col span={24}>
          <QysjtjAsj updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <QysjtjAbm updateTime={updateTime} />
        </Col>
        <Col span={12}>
          <QysjtjHor type='gr' updateTime={updateTime} />
        </Col>
        <Col span={12}>
          <QysjtjHor type='bm' updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <QysjtjHor type='xm' updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <Bndsfhttj updateTime={updateTime} />
        </Col>
        {/* <Col span={24}>
          <LastSjtj title="外委数据统计" updateTime={updateTime} />
        </Col>
        <Col span={24}>
          <LastSjtj title="外送数据统计" updateTime={updateTime} />
        </Col> */}
      </Row>
    </div>
  )
}

export default Index
